import { IconWorld as TablerIconWorld } from '@tabler/icons-react';

import { createOutlineIcon } from '@/components/icon/createOutlineIcon';

export const IconWorld = /*#__PURE__*/ createOutlineIcon(TablerIconWorld, 'IconWorld');
